<template>
<div >
  <el-table
    :data="tableData"
    style="width: 100%"
    class="expand-table">
    <el-table-column
      prop="platform"
      :label="$t('preApprovalLogin.platform')">
    </el-table-column>
    <el-table-column
      prop="storeName"
      :label="$t('preApprovalLogin.storeName')">
    </el-table-column>
    <el-table-column
      prop="area"
      :label="$t('preApprovalLogin.area')">
    </el-table-column>
    <el-table-column
      prop="status"
      :label="$t('preApprovalLogin.status')">
      <template #default="scope">
        <!-- <div class="sel-platform-checked">
          <i class="el-icon-check"></i>
        </div> -->
        <i class="lls-icon-success"></i>
      </template>
      <!-- Company Details -->

    </el-table-column>
  </el-table>
</div>
</template>
<script >
export default {
  name: 'preApprovalTable',
  components: {
    
  },
  props: {
    tableData: {
      type: [Array], 
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.expand-table ::v-deep {
  td,  th {
    height: 40px;
    padding: 0
  }
  th, .el-table__empty-text {
    color: #333333;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;

  }
  td {
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;

  }
  td, th.is-leaf {
    border-bottom: 1px solid #D9E9FF;
  } 
  
}
.lls-icon-success {
  color: #06d6a0;
}

</style>